import { useEffect } from 'react';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';
import TextField from '@mui/material/TextField';

import { parseComponents } from '../../../utils/whatsApp/transformMessages';

const extractVariables = (text = '') => {
    const regex = /{{(\d+)}}/g;
    const matches = [];
    let match;
    while ((match = regex.exec(text))) {
        matches.push({ index: parseInt(match[1]) - 1, raw: match[0] });
    }
    return matches;
};

const renderWithInputs = (text, values = [], onChange, section) => {
  const parts = text.split(/({{\d+}})/g);
  return (
    <Typography variant="body2" sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
      {parts.map((part, i) => {
        const match = part.match(/{{(\d+)}}/);
        if (match) {
          const index = parseInt(match[1]) - 1;
          return (
            <TextField
              key={`${section}-${i}`}
              size="small"
              variant="standard"
              value={values[index] || ''}
              onChange={(e) => {
                const updated = [...(values || [])];
                updated[index] = e.target.value;
                onChange(section, updated);
              }}
              sx={{ width: 100 }}
              placeholder={`Var ${index + 1}`}
              InputProps={{ sx: { color: 'white' } }}
            />
          );
        }
        return <span key={`${section}-text-${i}`}>{part}</span>;
      })}
    </Typography>
  );
};

export const TemplatePreview = ({ template, isSelected = false, viewSelector = false, templateVars, setTemplateVars }) => {
    const { header, body, footer, buttons } = parseComponents(template?.components || []);

    useEffect(() => {
        const newVars = {
            header: new Array(extractVariables(header).length).fill(''),
            body: new Array(extractVariables(body).length).fill(''),
            footer: new Array(extractVariables(footer).length).fill(''),
        };
        if (Array.isArray(buttons)) {
            newVars.buttons = buttons.map(btn => {
            if (btn.type === 'URL' && btn.url) {
                const count = extractVariables(btn.url).length;
                return new Array(count).fill('');
            }
            return [];
            });
        }
        setTemplateVars(newVars);
    }, [template, setTemplateVars]);

    const handleVarChange = (section, values) => {
        setTemplateVars((prev) => ({
            ...prev,
            [section]: values
        }));
    };

    if (!template || !templateVars) {
        return null;
    }


  return (
    <Paper
      elevation={3}
      sx={{
        backgroundColor: viewSelector && isSelected ? '#005c4b' : '#202c33',
        color: 'white',
        padding: 1.5,
        marginRight: 1,
        borderRadius: '12px',
        border: viewSelector && isSelected ? '2px solid #00a884' : '1px solid #2a3942',
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
          backgroundColor: viewSelector && isSelected ? '#005c4b' : '#2a3942',
          borderColor: viewSelector && isSelected ? '#00a884' : '#3b4a54',
        }
      }}
    >
        {header !== undefined && (
            <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 0.5 }}>
            {renderWithInputs(header, templateVars.header, handleVarChange, 'header')}
            </Typography>
        )}
        {body !== undefined && (
            <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
            {renderWithInputs(body, templateVars.body, handleVarChange, 'body')}
            </Typography>
        )}
        {footer !== undefined && (
            <Typography variant="caption" sx={{ color: '#aebac1', mt: 1, display: 'block' }}>
            {renderWithInputs(footer, templateVars.footer, handleVarChange, 'footer')}
            </Typography>
        )}
        {buttons  !== undefined && ( 
            buttons.map((btn, idx) => {
            const buttonVars = templateVars.buttons?.[idx] || [];
            const urlVariables = extractVariables(btn.url || '');

            return (
                <Stack key={idx} direction="column" spacing={0.5}>
                <Chip
                    label={btn.text || `Botón ${idx + 1}`}
                    color="success"
                    size="small"
                    variant="outlined"
                />
                {urlVariables.length > 0 &&
                    urlVariables.map((v, i) => (
                    <TextField
                        key={`button-${idx}-var-${i}`}
                        size="small"
                        variant="standard"
                        value={buttonVars[i] || ''}
                        onChange={(e) => {
                        const updatedButtons = [...(templateVars.buttons || [])];
                        const updatedVars = [...(updatedButtons[idx] || [])];
                        updatedVars[i] = e.target.value;
                        updatedButtons[idx] = updatedVars;
                        setTemplateVars((prev) => ({
                            ...prev,
                            buttons: updatedButtons
                        }));
                        }}
                        sx={{ width: 160 }}
                        placeholder={`Botón ${idx + 1} Var ${i + 1}`}
                        InputProps={{ sx: { color: 'white' } }}
                    />
                    ))}
                </Stack>
            );
            })
        )}


    </Paper>
  );
};
